import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

type PaymentTotalProps = {
  total: number;
};

const PaymentTotal = function PaymentTotal({
  total
}: PaymentTotalProps): React.ReactElement {
  return (
    <Grid container justify='flex-end'>
      <Grid item xs={3}>
        <Typography>
          <FormattedMessage
            id='PaymentTerms.PaymentTotal'
            defaultMessage='Payment Total'
          />
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography>
          <FormattedNumber value={total} currency='USD' style='currency' />
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PaymentTotal;
